import { initializeApp, getApps, getApp } from 'firebase/app';
import {
    getAuth,
    initializeAuth,
    indexedDBLocalPersistence,
    browserLocalPersistence
} from 'firebase/auth';
import { Capacitor } from '@capacitor/core';

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Initialize Firebase - check if already initialized to avoid errors on app resume
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Initialize Firebase Authentication with proper persistence
const initializeFirebaseAuth = () => {
    try {
        if (Capacitor.isNativePlatform()) {
            // Native platform: use IndexedDB persistence
            console.log('[FIREBASE] Initializing auth with IndexedDB persistence (native)');
            return initializeAuth(app, {
                persistence: indexedDBLocalPersistence
            });
        } else {
            // Web platform: use browser local persistence (survives page reloads and browser restarts)
            console.log('[FIREBASE] Initializing auth with browser local persistence (web)');
            return initializeAuth(app, {
                persistence: browserLocalPersistence  // KEY FIX: This persists across page reloads!
            });
        }
    } catch (error) {
        // If auth is already initialized, just get the existing instance
        if (error.code === 'auth/already-initialized') {
            console.log('[FIREBASE] Auth already initialized, using existing instance');
            return getAuth(app);
        } else {
            console.error('[FIREBASE] Error initializing auth:', error);
            // Fallback to default auth
            return getAuth(app);
        }
    }
};

// Export the auth instance
export const auth = initializeFirebaseAuth();

// Add listener to log auth state changes for debugging
auth.onAuthStateChanged((user) => {
    if (user) {
        console.log('[FIREBASE] Auth state: User signed in');
    } else {
        console.warn('[FIREBASE] ⚠️ Auth state: User signed out');
        console.trace('[FIREBASE] Stack trace for sign-out:');
    }
});

export default app;